import util from '@/libs/util'

const post = util.ajax.post

export const shopUrls = [
  // 查询
  '/accountShop/list'
]

export const shop = {}

shop.listShop = function (params) {
  return post('/accountShop/list', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/account/shop.js